import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.funktionsbereich-freigabe-berechtigung-rolle-entfernen';
import * as api from '../../../clients/benutzerverwaltung';

@Injectable()
export class BenutzerverwaltungFunktionsbereichFreigabeBerechtigungRolleEntfernenEffects {

    FunktionsbereichFreigabeBerechtigungRolleEntfernen$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_FUNKTIONSBEREICH_FREIGABE_BERECHTIGUNG_ROLLE_ENTFERNEN),
        mergeMap((x: ac.PostFunktionsbereichFreigabeBerechtigungRolleEntfernenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postFunktionsbereichFreigabeBerechtigungRolleEntfernen(x.rolleRequest).pipe(
                map((result: any) => {
                    return new ac.PostFunktionsbereichFreigabeBerechtigungRolleEntfernenErfolgreichAction(result, x.rolleRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostFunktionsbereichFreigabeBerechtigungRolleEntfernenFehlerAction(error, x.rolleRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.FunktionsbereicheCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.FunktionsbereicheCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.FunktionsbereicheCommandService);
        }
        return this.service;
    }
}
